import React from "react";

import { Trans, useTranslation } from "react-i18next";

function RichParagraph({ i18nKey }) {
  return (
    <p>
      <Trans
        ns="home"
        i18nKey={i18nKey}
        components={{
          strong: <strong />,
        }}
      />
    </p>
  );
}

export default function TermsConditionsContent({ showLastUpdated = true }) {
  const { t } = useTranslation("home");

  return (
    <div className="terms-content">
      {showLastUpdated ? (
        <div className="legal-page__updated">
          {t("legalPages.terms.lastUpdated")}
        </div>
      ) : null}

      {/* =====================================================
          1. GENERAL TERMS
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.general.title")}</h2>

        <p>{t("legalPages.terms.sections.general.p1")}</p>

        <p>{t("legalPages.terms.sections.general.p2")}</p>

        <p>{t("legalPages.terms.sections.general.p3")}</p>
      </section>

      {/* =====================================================
          2. LEG-UP PLATFORM
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.platform.title")}</h2>

        <p>{t("legalPages.terms.sections.platform.p1")}</p>

        <p>{t("legalPages.terms.sections.platform.p2")}</p>

        <RichParagraph i18nKey="legalPages.terms.sections.platform.p3" />

        <RichParagraph i18nKey="legalPages.terms.sections.platform.p4" />

        <RichParagraph i18nKey="legalPages.terms.sections.platform.p5" />

        <p>{t("legalPages.terms.sections.platform.p6")}</p>
      </section>

      {/* =====================================================
          3. REGISTRATION
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.registration.title")}</h2>

        <p>{t("legalPages.terms.sections.registration.p1")}</p>

        <RichParagraph i18nKey="legalPages.terms.sections.registration.p2" />

        <p>{t("legalPages.terms.sections.registration.p3")}</p>

        <p>{t("legalPages.terms.sections.registration.p4")}</p>

        <p>{t("legalPages.terms.sections.registration.p5")}</p>
      </section>

      {/* =====================================================
          4. USER CONTENT
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.content.title")}</h2>

        <p>{t("legalPages.terms.sections.content.p1")}</p>

        <p>{t("legalPages.terms.sections.content.p2")}</p>

        <RichParagraph i18nKey="legalPages.terms.sections.content.p3" />

        <p>{t("legalPages.terms.sections.content.p4")}</p>
      </section>

      {/* =====================================================
          5. PROHIBITED USE
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.prohibited.title")}</h2>

        <p>{t("legalPages.terms.sections.prohibited.intro")}</p>

        <ul>
          {Array.from(
            {
              length: 8,
            },
            (_, index) => (
              <li key={index + 1}>
                {t(`legalPages.terms.sections.prohibited.items.${index + 1}`)}
              </li>
            ),
          )}
        </ul>
      </section>

      {/* =====================================================
          6. ORGANISATIONS
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.organisations.title")}</h2>

        <RichParagraph i18nKey="legalPages.terms.sections.organisations.p1" />

        <RichParagraph i18nKey="legalPages.terms.sections.organisations.p2" />

        <p>{t("legalPages.terms.sections.organisations.p3")}</p>
      </section>

      {/* =====================================================
          7. PLATFORM MANAGEMENT
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.management.title")}</h2>

        <p>{t("legalPages.terms.sections.management.p1")}</p>

        <p>{t("legalPages.terms.sections.management.p2")}</p>

        <p>{t("legalPages.terms.sections.management.p3")}</p>
      </section>

      {/* =====================================================
          8. TERMINATION
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.termination.title")}</h2>

        <p>{t("legalPages.terms.sections.termination.p1")}</p>

        <p>{t("legalPages.terms.sections.termination.p2")}</p>

        <p>{t("legalPages.terms.sections.termination.p3")}</p>
      </section>

      {/* =====================================================
          9. MODIFICATIONS
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.modifications.title")}</h2>

        <h3>{t("legalPages.terms.sections.modifications.termsTitle")}</h3>

        <p>{t("legalPages.terms.sections.modifications.p1")}</p>

        <p>{t("legalPages.terms.sections.modifications.p2")}</p>

        <h3>{t("legalPages.terms.sections.modifications.platformTitle")}</h3>

        <p>{t("legalPages.terms.sections.modifications.p3")}</p>

        <p>{t("legalPages.terms.sections.modifications.p4")}</p>
      </section>

      {/* =====================================================
          10. THIRD PARTY
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.thirdParty.title")}</h2>

        <p>{t("legalPages.terms.sections.thirdParty.p1")}</p>

        <p>{t("legalPages.terms.sections.thirdParty.p2")}</p>
      </section>

      {/* =====================================================
          11. INTELLECTUAL PROPERTY
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.ip.title")}</h2>

        <p>{t("legalPages.terms.sections.ip.p1")}</p>

        <p>{t("legalPages.terms.sections.ip.p2")}</p>

        <p>{t("legalPages.terms.sections.ip.p3")}</p>
      </section>

      {/* =====================================================
          12. DATA
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.data.title")}</h2>

        <p>{t("legalPages.terms.sections.data.p1")}</p>

        <RichParagraph i18nKey="legalPages.terms.sections.data.p2" />

        <p>{t("legalPages.terms.sections.data.p3")}</p>

        <p>{t("legalPages.terms.sections.data.p4")}</p>
      </section>

      {/* =====================================================
          13. LIABILITY
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.liability.title")}</h2>

        <RichParagraph i18nKey="legalPages.terms.sections.liability.p1" />

        <p>{t("legalPages.terms.sections.liability.p2")}</p>

        <RichParagraph i18nKey="legalPages.terms.sections.liability.p3" />

        <p>{t("legalPages.terms.sections.liability.p4")}</p>
      </section>

      {/* =====================================================
          14. DISPUTES
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.disputes.title")}</h2>

        <p>{t("legalPages.terms.sections.disputes.p1")}</p>

        <p>{t("legalPages.terms.sections.disputes.p2")}</p>
      </section>

      {/* =====================================================
          15. CONTACT
          ===================================================== */}

      <section className="legal-page__section">
        <h2>{t("legalPages.terms.sections.contact.title")}</h2>

        <p>{t("legalPages.terms.sections.contact.p1")}</p>
      </section>
    </div>
  );
}
